import { render, staticRenderFns } from "./RevisaoVisualizacao.vue?vue&type=template&id=2be9556c&scoped=true"
import script from "./RevisaoVisualizacao.vue?vue&type=script&lang=js"
export * from "./RevisaoVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9556c",
  null
  
)

export default component.exports